import React, { useContext, useEffect } from 'react'
import { func } from 'prop-types'

import { ENGRAVING_MINI_ICONS } from 'utils/constants'

import { EngravingContext } from 'components/buy/Engraving/EngravingContext'
import StepBack from 'components/buy/Engraving/StepBack'
import Heading from 'components/buy/Engraving/Heading'
import List from 'components/buy/Engraving/List'
import EngravingOption from 'components/buy/Engraving/EngravingOption'

const MiniIcon = ({ setStep }) => {
  const { engraving, setEngraving, currentView, setCurrentView } = useContext(EngravingContext)

  useEffect(() => {
    setCurrentView({ ...currentView, item: 'front', step: 'miniIcon' })
  }, [])

  return (
    <>
      <Heading
        title="Choose the mini icon you like"
        back={() => <StepBack setStep={setStep} initialstep={'initialstep'} />}
      />
      <List row={5}>
        {ENGRAVING_MINI_ICONS.map((icon, idx) => (
          <EngravingOption
            key={idx}
            selected={engraving.front.miniIcon.value === icon.value}
            onClick={() => {
              const upToDateEngraving = {
                ...engraving,
                front: {
                  ...engraving.front,
                  miniIcon: {
                    ...engraving.front.miniIcon,
                    value: icon.value,
                    name: icon.name
                  }
                }
              }

              setEngraving(upToDateEngraving)
            }}
            icon={`${process.env.BASE_PATH}/images/engraving/icons/thumbnails/${icon.name.toLowerCase()}.svg`}
            name={icon.name}
            isNew={icon.isNew}
          />
        ))}
      </List>
    </>
  )
}

MiniIcon.propTypes = {
  setStep: func.isRequired
}

export default MiniIcon
